// extracted by mini-css-extract-plugin
export default {"root":"VkMusicBlock__root--OHjVv","header":"VkMusicBlock__header--364BA","subtitle":"VkMusicBlock__subtitle--17mTn"};